import React from "react";

const Java_For = () => {
  return (
    <div>
      <h1>Java For</h1>
      <p>This page provides explanations, examples, and common use-cases for Java For in Java.</p>
    </div>
  );
};

export default Java_For;
